import { render, staticRenderFns } from "./LandingSectionVideo.vue?vue&type=template&id=b8d2de10&scoped=true&"
import script from "./LandingSectionVideo.vue?vue&type=script&lang=js&"
export * from "./LandingSectionVideo.vue?vue&type=script&lang=js&"
import style0 from "./LandingSectionVideo.vue?vue&type=style&index=0&id=b8d2de10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d2de10",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LandingText: require('/home/circleci/repo/components/landing/elements/LandingText.vue').default,LandingButton: require('/home/circleci/repo/components/landing/elements/LandingButton.vue').default,LandingVideo: require('/home/circleci/repo/components/landing/elements/LandingVideo.vue').default})
